import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {User} from "../../../user/user";
import {PaymentDialogComponent} from "../../billing/payment-dialog/payment-dialog.component";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";
import {filter, switchMap} from "rxjs/operators";
import {Website} from "../../../websites/website/website";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {Router} from "@angular/router";
import {DbModalService} from "../../../modules/modal/modal";
import {Utils} from "../../../shared/utils/utils";

@Component({
    selector: 'db-payment-button',
    templateUrl: './db-payment-button.component.html',
    styleUrls: ['./db-payment-button.component.scss'],
    standalone: false
})
export class DbPaymentButtonComponent implements OnInit {

  @Input() campaignInfo: any = null;
  @Input() userSubscription: UserSubscription;
  @Input() upgradeSubscription: UserSubscription;
  @Input() aiStarterAnnual: UserSubscription;
  @Input() user: User;
  @Input() trialDeleteDay: any;
  @Output() activateAddOns: EventEmitter<void> = new EventEmitter<void>();

  public websiteCopied: boolean;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public UserSubscriptionType: any = UserSubscriptionType;
  public showPercentOffer: boolean;
  public twCareLink: string = 'https://help.10web.io/hc/en-us/requests/new';

  constructor(
    private _dialogService: DialogService,
    private _modalService: DbModalService,
    private _store: Store<fromStore.DbStoreState>,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    this._showPercentOffer();
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((websitesLoaded: boolean) => websitesLoaded),
        switchMap(() => this._store.select(fromStore.getHostedWebsites)),
        filter((hostedWebsites: Website[]): boolean => !!hostedWebsites.length)
      )
      .subscribe((hostedWebsites: Website[]) => {
        this.websiteCopied = true;
      });
  }

  private _showPercentOffer() {
    const percentOfferEndDate = new Date("2024-01-30 18:00:00").getTime();
    const datesDiff = Utils.getTimeDiffFromToday(percentOfferEndDate);
    this.showPercentOffer = datesDiff && this.userSubscription && this.userSubscription.trialBoosterClient;
  }

  public buyNow(): void {
      this._dialogService
        .addDialog(PaymentDialogComponent, {
          upgradeSubscription: this.userSubscription,
          fromDialog: false,
          showAdditional: true
        });
  }

  public renewUserSubscription(userSubscription: UserSubscription, renew: boolean): void {
    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.userSubscription,
        fromDialog: false,
        renew: renew
      })
      .subscribe((reopenLast: boolean): void => {
        if (reopenLast) {
          this._store.dispatch(new fromStore.LoadUser());
        }
      });
  }

  public sendFreeUpgradeEvent(): void {
    const analyticsData = {
      eventCategory: this.userSubscription && this.userSubscription.trialBoosterClient ? 'Dashboard Action' : 'Free Upgrade Offer',
      eventAction: "Upgrade Page view",
      eventLabel: this.userSubscription && this.userSubscription.trialBoosterClient ? 'Speed Booster: Subscription page' : "Subscription page",
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this._router.navigate(['/upgrade-plan']);
  }

}
